import { useEffect } from 'react';
import { useFeatureFlags, useGraphQLQuery } from 'studio5/contexts';
import { GET_ACCOUNT_TRAITS } from './queries';
import { GetAccountTraitsQuery } from './__generated__/queries.types';

const useLaunchDarkly = () => {
  const { initialize } = useFeatureFlags();

  const [{ data, fetching }] = useGraphQLQuery<GetAccountTraitsQuery>({
    query: GET_ACCOUNT_TRAITS,
  });

  useEffect(() => {
    if (!fetching) {
      initialize({
        kind: 'user',
        key: data?.account.id,
        tier: data?.account.tier,
        createdAt: data?.account.createdAt,
        region: import.meta.env.AWS_REGION,
      });
    }
  }, [fetching, data, initialize]);

  return null;
};

export default useLaunchDarkly;
